enum ShippingType {
    PARALLEL, SEQUENTIAL, MASSIVE
}

enum SignatureType {
    HANDWRITE, OTP, HANDWRITE_OTP
}

enum AdditionalSettings {
    IDENTITY, COLLECT, IDENTITY_COLLECT
}

export class Workflow {
    public static readonly SHIPPING_TYPE = ShippingType;
    public static readonly SIGNATURE_TYPE = SignatureType;
    public static readonly ADDITIONAL_SETTINGS = AdditionalSettings;
    public static readonly WORKFLOW_NAME = [
        'WORKFLOW.SHIPPING_TYPE.PARALLEL',
        'WORKFLOW.SHIPPING_TYPE.SEQUENTIAL',
        'WORKFLOW.SHIPPING_TYPE.MASSIVE',
    ];
    
    public static readonly PARALLEL = 'parallel';
    public static readonly SEQUENTIAL = 'sequential';
    public static readonly MASSIVE = 'massive';
    
    public static readonly SIGNATURE_HANDWRITTEN = 'handwritten';
    public static readonly SIGNATURE_OTP = 'otp';
    public static readonly SIGNATURE_HANDWRITTEN_OTP = 'handwritten_otp';
    public static readonly SIGNATURE_SIMPLE = 'simple';
    public static readonly SIGNATURE_CERTIFICATE = 'certificate';
    public static readonly SIGNATURE_CERTIFICATE_OTP = 'certificate_otp';
    public static readonly SIGNATURE_EMAIL_CERTIFICATE = 'email_certificate';
    public static readonly SIGNATURE_CERTIFIED_SMS = 'certified_sms';
    public static readonly SIGNATURE_BASIC_SIMPLE = 'basic_simple';
    public static readonly SIGNATURE_OTP_EMAIL = 'otp_email'
    public static readonly SIGNATURE_BASIC_HANDWRITTEN = 'basic_handwritten';
    
    public static readonly SIGNATURE_TYPES = [
        Workflow.SIGNATURE_HANDWRITTEN,
        Workflow.SIGNATURE_OTP,
        Workflow.SIGNATURE_HANDWRITTEN_OTP,
        Workflow.SIGNATURE_SIMPLE,
        Workflow.SIGNATURE_CERTIFICATE,
        Workflow.SIGNATURE_EMAIL_CERTIFICATE,
        Workflow.SIGNATURE_BASIC_HANDWRITTEN,
        Workflow.SIGNATURE_BASIC_SIMPLE,
        Workflow.SIGNATURE_OTP_EMAIL
        
    ];
    
    static signatureIndex(signature_key) {
        return Workflow.SIGNATURE_TYPES.indexOf(signature_key);
    }
    
    static disableSignatureBoxes(signature_type, debug = false) {
        const disableFor = [Workflow.signatureIndex(Workflow.SIGNATURE_OTP), /*Workflow.signatureIndex(Workflow.SIGNATURE_SIMPLE),*/  Workflow.signatureIndex(Workflow.SIGNATURE_EMAIL_CERTIFICATE)];
        if (debug) {
            console.log('debug disableSignatureBoxes', disableFor, disableFor.includes(signature_type), signature_type);
        }
        return disableFor.includes(signature_type);
    }
    
    static hasBiometry(signature_type) {
        return [Workflow.SIGNATURE_HANDWRITTEN, Workflow.SIGNATURE_BASIC_HANDWRITTEN].includes(signature_type);
    }
}
